
const KJobFailedResponse = () => import('./pages/bodypages/KJobFailedResponse')
const KsFirstPurchase = () => import('./pages/bodypages/KsFirstPurchase')
const KsFirstPurchaseSuccess = () => import('./pages/bodypages/KsFirstPurchaseSuccess')
const KsRegister = () => import('./pages/bodypages/KsRegister')
const KsRegisterStep1 = () => import('./pages/bodypages/KsRegisterStep1')
const KsLogin = () => import('./pages/bodypages/KsLogin')
const KsPasswordReset = () => import('./pages/bodypages/KsPasswordReset')
const Kbody = () => import('./components/partials/Kbody')
const Kdashboard = () => import('./components/partials/Kdashboard')
const KdAllPurchases = () => import('./pages/dashboardpages/KdAllPurchases')
// const KdMakePurchase = () => import('./pages/dashboardpages/KdMakePurchase')
const KdPurchaseSuccess = () => import('./pages/dashboardpages/KdPurchaseSuccess')
const KdCounters = () => import('./pages/dashboardpages/KdCounters')
const KdBills = () => import('./pages/dashboardpages/KdBills')
const KdCounterSeen = () => import('./pages/dashboardpages/KdCounterSeen')
const KdAccount = () => import('./pages/dashboardpages/KdAccount')
const KdJobFailedResponse = () => import('./pages/dashboardpages/KdJobFailedResponse')
//const Foo = () => import('')

import {store} from './store/store'

export const routes = [
    { path: '/', component: Kbody,
    
        children: [
            { path: '', component: KsFirstPurchase},
            { 
                path: 'errorRecharge',
                meta: { socketRoute: true }, 
                component: KJobFailedResponse,
                beforeEnter: (to, from, next) => {
                    if(store.getters.getJobFailedTransact.amount) {
                        next()
                    }
                    else {
                        next('/')
                    }
                }
            },
            { 
                path: 'bigframe', 
                meta: { socketRoute: true },
                component: KsFirstPurchaseSuccess,
                beforeEnter: (to, from, next) => {
                    if(store.getters.getPaySuccessData.total) {
                        next()
                    }
                    else {
                        next('/')
                    }
                }
            },
            { 
                path: 'signframe', 
                component: KsRegister,
                beforeEnter: (to, from, next) => {
                    if(store.getters.getUser.email != null || store.getters.getUser.phone != null) {
                        next()
                    }
                    else {
                        next('/')
                    }
                }
            },
            { path: 'signsuccess', component: KsLogin},
            { path: 'register', component: KsRegisterStep1},
            { path: 'resetpwd', component: KsPasswordReset},
        ]
    
    },
    { 
        path: '/dashboard', component: Kdashboard,
        meta: { requiresAuth: true },
    
        children: [
            { path: '', component: KdAllPurchases},
            { 
                path: 'errorRecharge',
                meta: { socketRoute: true }, 
                component: KdJobFailedResponse,
                beforeEnter: (to, from, next) => {
                    if(store.getters.getJobFailedTransact.amount) {
                        next()
                    }
                    else {
                        next('/dashboard')
                    }
                }
            },
            // { path: 'recharge', component: KdMakePurchase},
            { 
                path: 'success', 
                meta: { socketRoute: true },
                component: KdPurchaseSuccess,
                beforeEnter: (to, from, next) => {
                    if(store.getters.getDashPaySuccessData.total) {
                        next()
                    }
                    else {
                        next('/dashboard')
                    }
                }
            },
            { path: 'counters', component: KdCounters},
            { path: 'bills', component: KdBills},
            { 
                path: 'counterseen', 
                component: KdCounterSeen,
                beforeEnter: (to, from, next) => {
                    if(store.getters.getMeterTotalRecharge != null) {
                        next()
                    }
                    else {
                        next('/dashboard/counters')
                    }
                }
            },
            { path: 'account', component: KdAccount},
        ],
    },
    { path: '*', redirect: '/'}
    
]